import { useState } from "react";
import { Close32 } from "src/assets/mapfre-icons-components";

export const TestHeader = () => {
  const [isClose, setIsClose] = useState(false);
  const environment = import.meta.env.VITE_APP_ENVIRONMENT || "development";

  const handleClose = () => setIsClose(true);

  if (environment === "production") return null;
  if (isClose) return null;

  return (
    <>
      <header className="flex h-9 items-center justify-around bg-red-600 py-1 text-white">
        <p className="text-sm">Você está acessando o ambiente de testes!</p>
        <button
          type="button"
          aria-label="Fechar aviso de ambiente de testes"
          onClick={handleClose}
          className="aspect-square rounded-md p-1 hover:bg-white/15"
        >
          <Close32 className="size-4" />
        </button>
      </header>
    </>
  );
};

export default TestHeader;
